import {
  HttpEvent,
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
} from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { AppException } from './http-exceptions';

import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';

export const interceptHeaders: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  const authSercice = inject(AuthService);
  const router = inject(Router);
  const token =
    authSercice.currentUser !== null ? authSercice.currentUser.token : null;

  if (token) {
    if (authSercice.isTokenExpired()) {
      authSercice.logOut();
      // return new Observable<HttpEvent<any>>();
    }

    const modifiedReq = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
        'Referrer-Policy': 'no-referrer',
      },
    });

    return next(modifiedReq).pipe(
      catchError((err: any) => throwError(() => new AppException(err)))
      // catchError((err: any) => throwError(() => err))
    );
  }

  return next(req).pipe(
    catchError((err: any) => throwError(() => new AppException(err)))
    // catchError((err: any) => throwError(() => err))
  );
};
